import { createWeb3ReactStoreAndActions } from '@web3-react/store';
import create from 'zustand';
import { useEffect, useMemo, useState } from 'react';
import { Web3Provider } from '@ethersproject/providers';
export function initializeConnector(Connector, constructorArgs = [] // TODO: really unfortunate that we can't type this
) {
    const [store, actions] = createWeb3ReactStoreAndActions();
    const instance = new Connector(actions, ...constructorArgs);
    const useConnector = create(store);
    return [instance, useConnector];
}
const CHAIN_ID = (state) => state.chainId;
export function useChainId(useConnector) {
    return useConnector(CHAIN_ID);
}
const ACCOUNTS = (state) => state.accounts;
export function useAccounts(useConnector) {
    return useConnector(ACCOUNTS);
}
export function useAccount(useConnector) {
    var _a;
    return (_a = useConnector(ACCOUNTS)) === null || _a === void 0 ? void 0 : _a[0];
}
const ACTIVATING = (state) => state.activating;
export function useActivating(useConnector) {
    return useConnector(ACTIVATING);
}
const ERROR = (state) => state.error;
export function useError(useConnector) {
    return useConnector(ERROR);
}
export function useProvider(connector, useConnector) {
    const chainId = useChainId(useConnector);
    const accounts = useAccounts(useConnector);
    return useMemo(() => {
        if (chainId && accounts && connector.provider) {
            return new Web3Provider(connector.provider);
        }
    }, [chainId, accounts, connector.provider]);
}
export function useENSNames(connector, useConnector) {
    const provider = useProvider(connector, useConnector);
    const accounts = useAccounts(useConnector);
    const [ENSNames, setENSNames] = useState(undefined);
    useEffect(() => {
        if (provider && (accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
            let stale = false;
            Promise.all(accounts.map((account) => provider.lookupAddress(account)))
                .then((ENSNames) => {
                if (!stale) {
                    setENSNames(ENSNames);
                }
            })
                .catch((error) => {
                console.debug('Could not fetch ENS names', error);
            });
            return () => {
                stale = true;
                setENSNames(undefined);
            };
        }
    }, [provider, accounts]);
    return ENSNames;
}
export function useENSName(connector, useConnector) {
    const provider = useProvider(connector, useConnector);
    const account = useAccount(useConnector);
    const [ENSName, setENSName] = useState(undefined);
    useEffect(() => {
        if (provider && account) {
            let stale = false;
            provider
                .lookupAddress(account)
                .then((ENSName) => {
                if (!stale) {
                    setENSName(ENSName);
                }
            })
                .catch((error) => {
                console.debug('Could not fetch ENS name', error);
            });
            return () => {
                stale = true;
                setENSName(undefined);
            };
        }
    }, [provider, account]);
    return ENSName;
}
